import { DigitalNavigationStep, NavigationContext, PrintNavigationStep } from '../CardCustomizer.types';
import { createContext } from '@shared/utils/createContext';

const [NavigationProvider, useNavigationContext] = createContext<NavigationContext<PrintNavigationStep>>({ name: 'Navigation' });
const [DigitalNavigationProvider, useDigitalNavigationContext] = createContext<NavigationContext<DigitalNavigationStep>>({ name: 'Navigation' });

export { NavigationProvider, useNavigationContext, DigitalNavigationProvider, useDigitalNavigationContext };
